export default __webpack_public_path__ + "static/media/master.7a4966e4.png";